import Scroller from './components/Scroller'
export default Scroller

window.Scroller = Scroller



// WEBPACK FOOTER //
// ./~/vue-scroller/src/index.js